import { render } from "./CommissionCreationModal.vue?vue&type=template&id=916df0ac&ts=true&lang=pug"
import script from "./CommissionCreationModal.vue?vue&type=script&lang=ts"
export * from "./CommissionCreationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__